import {kmApiLink} from "@pg-mono/km-routes";

import axios from "../../km_app/utils/fetch";
import {ActivitySource} from "../constants/ActivitySource";

export const mailingUnsubscribeUser = (emailHash: string, verificationHash: string, activitySource: ActivitySource) => {
    return axios.put(kmApiLink.unsubscribe.mailing.base({emailHash, verificationHash}), {activity_source: activitySource});
};
import {kmApiLink} from "@pg-mono/km-routes";

import axios from "../../km_app/utils/fetch";
import {ActivitySource} from "../constants/ActivitySource";

export const mailingUnsubscribeUser = (emailHash: string, verificationHash: string, activitySource: ActivitySource) => {
    return axios.put(kmApiLink.unsubscribe.mailing.base({emailHash, verificationHash}), {activity_source: activitySource});
};
